import { FiLock, FiMail, FiEye, FiEyeOff } from "react-icons/fi";
import styles from "../styles/Login.module.css";

const FormWrapper = ({ formCreds, setFormCreds, onSubmit }) => {
  return (
    <section className={styles.formWrapper}>
      <form className={styles.card} onSubmit={onSubmit}>
        <p className={styles.title}>Log in</p>
        <div className={styles.inputWrapper}>
          <p className={styles.label}>Username/Email address</p>
          <div className={styles.inputRow}>
            <span className={styles.leftIcon}>
              <FiMail size={18} />
            </span>
            <input
              data-test-login-input-user
              // type="email"
              placeholder="Username or email"
              className={styles.input}
              value={formCreds.email}
              onChange={(e) =>
                setFormCreds({ ...formCreds, email: e.target.value })
              }
            />
          </div>
        </div>
        <div className={styles.inputWrapper}>
          <p className={styles.label}>Password</p>
          <div className={styles.inputRow}>
            <span className={styles.leftIcon}>
              <FiLock size={18} />
            </span>
            <input
              data-test-login-input-password
              id="password"
              type={formCreds.showPassword ? "text" : "password"}
              className={styles.input}
              placeholder="••••••••"
              value={formCreds.password}
              onChange={(e) =>
                setFormCreds({ ...formCreds, password: e.target.value })
              }
              required
            />
            <button
              type="button"
              className={styles.eyeBtn}
              aria-label={
                formCreds.showPassword ? "Hide password" : "Show password"
              }
              onClick={() =>
                setFormCreds({
                  ...formCreds,
                  showPassword: !formCreds.showPassword,
                })
              }
            >
              {formCreds.showPassword ? (
                <FiEyeOff size={18} />
              ) : (
                <FiEye size={18} />
              )}
            </button>
          </div>
        </div>
        <span className={styles.errorText}>{formCreds.error ?? ""}</span>
        <button
          data-test-login-submit
          type="submit"
          onClick={onSubmit}
          className={styles.submitButton}
        >
          {formCreds.loading ? <div className={styles.spinner} /> : "Sign In"}
        </button>
      </form>
    </section>
  );
};

export default FormWrapper;
